import styles from './ModalEditMenu.module.css'
import Modal from 'react-modal'
import FieldModalEdit from './FieldModalEdit'
import ButtonDefault from '../../ButtonDefault'
import soundClick from '../../../audios/clickAudio.mp3'
import PopupRepeatedAlternatives from '../../Popups/PopupRepeatedAlternatives'
import PopupCheckAlternativeAnswer from '../../Popups/PopupCheckAlternativeAnswer'
import PopupAlreadySavedModalEdit from '../../Popups/PopupAlreadySavedModalEdit'
import PopupAlertMessage from '../../Popups/PopupAlertMessage'
import DescriptionIconMenuTools from '../../MenuTools/DescriptionIconMenuTools'
import { useContext, useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import { MdEditSquare } from "react-icons/md"
import { TiDeleteOutline } from "react-icons/ti"
import { DataContext } from '../../DataContext'
import { isEqual } from 'lodash'

// certifique-se de vincular o modal ao seu appElement
Modal.setAppElement('#root')

function ModalEditMenu({ questionMain, optionMain, optionMainNumberId, questionMulti, 
  optionMulti, optionMultiNumberId, activeDescriptionIcon, setActiveDescriptionIcon }) {

  // questionMain
  const [questionTextMain, setQuestionTextMain] = useState(questionMain?.questionText)
  const [imageQuestionMain, setImageQuestionMain] = useState(questionMain?.imageQuestion)
  const [correctAnswerMain, setCorrectAnswerMain] = useState(questionMain?.correctAnswer)
  const [iconDescriptionMain, setIconDescriptionMain] = useState(questionMain?.iconDescription)
  const [descriptionMain, setDescriptionMain] = useState(questionMain?.description)
  const [imageDescriptionMain, setImageDescriptionMain] = useState(questionMain?.imageDescription)
  const [questionNumberMain] = useState(questionMain?.questionNumber)

  // optionMain
  const [optionAMain, setOptionAMain] = useState(optionMain && optionMain[0])
  const [optionBMain, setOptionBMain] = useState(optionMain && optionMain[1])
  const [optionCMain, setOptionCMain] = useState(optionMain && optionMain[2])
  const [optionDMain, setOptionDMain] = useState(optionMain && optionMain[3])
  const [optionEMain, setOptionEMain] = useState(optionMain && optionMain[4])

  // questionMulti
  const [questionTextMulti, setQuestionTextMulti] = useState(questionMulti?.questionText)
  const [imageQuestionMulti, setImageQuestionMulti] = useState(questionMulti?.imageQuestion)
  const [correctAnswerMulti1, setCorrectAnswerMulti1] = useState(questionMulti?.correctAnswer1)
  const [correctAnswerMulti2, setCorrectAnswerMulti2] = useState(questionMulti?.correctAnswer2)
  const [iconDescriptionMulti, setIconDescriptionMulti] = useState(questionMulti?.iconDescription)
  const [descriptionMulti, setDescriptionMulti] = useState(questionMulti?.description)
  const [imageDescriptionMulti, setImageDescriptionMulti] = useState(questionMulti?.imageDescription)
  const [questionNumberMulti] = useState(questionMulti?.questionNumber)

  // optionMulti
  const [optionAMulti, setOptionAMulti] = useState(optionMulti && optionMulti[0])
  const [optionBMulti, setOptionBMulti] = useState(optionMulti && optionMulti[1])
  const [optionCMulti, setOptionCMulti] = useState(optionMulti && optionMulti[2])
  const [optionDMulti, setOptionDMulti] = useState(optionMulti && optionMulti[3])
  const [optionEMulti, setOptionEMulti] = useState(optionMulti && optionMulti[4])

  // questionThreeMulti
  const [questionTextThreeMulti, setQuestionTextThreeMulti] = useState(questionMulti?.questionText)
  const [imageQuestionThreeMulti, setImageQuestionThreeMulti] = useState(questionMulti?.imageQuestion)
  const [correctAnswerThreeMulti1, setCorrectAnswerThreeMulti1] = useState(questionMulti?.correctAnswer1)
  const [correctAnswerThreeMulti2, setCorrectAnswerThreeMulti2] = useState(questionMulti?.correctAnswer2)
  const [correctAnswerThreeMulti3, setCorrectAnswerThreeMulti3] = useState(questionMulti?.correctAnswer3)
  const [iconDescriptionThreeMulti, setIconDescriptionThreeMulti] = useState(questionMulti?.iconDescription)
  const [descriptionThreeMulti, setDescriptionThreeMulti] = useState(questionMulti?.description)
  const [imageDescriptionThreeMulti, setImageDescriptionThreeMulti] = useState(questionMulti?.imageDescription)
  const [questionNumberThreeMulti] = useState(questionMulti?.questionNumber)

  // optionThreeMulti
  const [optionAThreeMulti, setOptionAThreeMulti] = useState(optionMulti && optionMulti[0])
  const [optionBThreeMulti, setOptionBThreeMulti] = useState(optionMulti && optionMulti[1])
  const [optionCThreeMulti, setOptionCThreeMulti] = useState(optionMulti && optionMulti[2])
  const [optionDThreeMulti, setOptionDThreeMulti] = useState(optionMulti && optionMulti[3])
  const [optionEThreeMulti, setOptionEThreeMulti] = useState(optionMulti && optionMulti[4])
  const [optionFThreeMulti, setOptionFThreeMulti] = useState(optionMulti && optionMulti[5])

  const [newOption, setNewOption] = useState([]) // lista optionMain
  const [newMultiOption, setNewMultiOption] = useState([]) // lista optionMulti
  const [newThreeMultiOption, setNewThreeMultiOption] = useState([]) // lista optionThreeMulti

  // ativa o componente 'PopupRepeatedAlternatives' na ModalEditMenu
  const [activePopupRepeatedAlternativesModalEdit, setActivePopupRepeatedAlternativesModalEdit] = useState(false) 

  // ativa o componente 'PopupCheckAlternativeAnswer' na ModalEditMenu
  const [activePopupcheckAlternativeAnswerModalForms1, setActivePopupcheckAlternativeAnswerModalForms1] = useState(false)
  const [activePopupcheckAlternativeAnswerModalForms2, setActivePopupcheckAlternativeAnswerModalForms2] = useState(false)
  const [activePopupcheckAlternativeAnswerModalForms3, setActivePopupcheckAlternativeAnswerModalForms3] = useState(false)
  
  // ativa o componente 'PopupAlreadySavedModalEdit' na ModalEditMenu
  const [activePopupAlreadySavedModalEdit, setActivePopupAlreadySavedModalEdit] = useState(false)

  const [staticQuestionEditAlert, setStaticQuestionEditAlert] = useState(false) // ativa o componente PopupAlertMessage
  const [staticQuestionClearDisabledAlert, setStaticQuestionClearDisabledAlert] = useState(false) // ativa o componente PopupAlertMessage

  // variáveis para ativar e desativar a mensagem de erro
  const [errorMessageModalEdit] = useState("This required field is empty.")
  const [voidField, setVoidField] = useState([])

  // variáveis para checar as respostas repetidas
  const [checkEqualAnswersMulti, setCheckEqualAnswersMulti] = useState(false) 
  const [checkEqualAnswersThreeMulti, setCheckEqualAnswersThreeMulti] = useState(false)

  // chamando as funções 'repeatedAlternativesDefault' e 'checkAlternativeAnswerDefault' através do 'useOutletContext' criada na PageBase
  const { repeatedAlternativesDefault, checkAlternativeAnswerDefault, mute, activePageDemo, activePageMain, activePageMulti, activePageThreeMulti, setActiveModalEditMenu, 
    checkAnswers } = useOutletContext()

  const { listUnicQuestionsContext, listUnicOptionsContext, listMultiQuestionsContext, listMultiOptionsContext, listThreeMultiQuestionsContext, 
    listThreeMultiOptionsContext, putApi, setPutApi } = useContext(DataContext)

  const audioClick = new Audio(soundClick) // armazena o som 'soundClick'

  const [modalIsOpen, setModalIsOpen] = useState(false)
  
  useEffect(() => {
    setOptionAMain(optionMain && optionMain[0])
    setOptionBMain(optionMain && optionMain[1])
    setOptionCMain(optionMain && optionMain[2])
    setOptionDMain(optionMain && optionMain[3])
    setOptionEMain(optionMain && optionMain[4])

    setOptionAMulti(optionMulti && optionMulti[0])
    setOptionBMulti(optionMulti && optionMulti[1])
    setOptionCMulti(optionMulti && optionMulti[2])
    setOptionDMulti(optionMulti && optionMulti[3])
    setOptionEMulti(optionMulti && optionMulti[4])

    setOptionAThreeMulti(optionMulti && optionMulti[0])
    setOptionBThreeMulti(optionMulti && optionMulti[1])
    setOptionCThreeMulti(optionMulti && optionMulti[2])
    setOptionDThreeMulti(optionMulti && optionMulti[3])
    setOptionEThreeMulti(optionMulti && optionMulti[4])
    setOptionFThreeMulti(optionMulti && optionMulti[5])

  }, [optionMain, optionMulti]) // sempre atualizar as opções quando houver mudança

  useEffect(() => {
    setNewOption([optionAMain, optionBMain, optionCMain, optionDMain, optionEMain])

    setNewMultiOption([optionAMulti, optionBMulti, optionCMulti, optionDMulti, optionEMulti])

    setNewThreeMultiOption([optionAThreeMulti, optionBThreeMulti, optionCThreeMulti, optionDThreeMulti, optionEThreeMulti, optionFThreeMulti])

  }, [optionAMain, optionBMain, optionCMain, optionDMain, optionEMain, 
      optionAMulti, optionBMulti, optionCMulti, optionDMulti, optionEMulti,
      optionAThreeMulti, optionBThreeMulti, optionCThreeMulti, optionDThreeMulti, optionEThreeMulti, optionFThreeMulti
    ])

  function openModal() {
    setModalIsOpen(true)

    // voltando ao estado original de todas as variáveis ao abrir a modal
    // questionMain
    setQuestionTextMain(questionMain?.questionText)
    setImageQuestionMain(questionMain?.imageQuestion)
    setCorrectAnswerMain(questionMain?.correctAnswer)
    setIconDescriptionMain(questionMain?.iconDescription)
    setDescriptionMain(questionMain?.description)
    setImageDescriptionMain(questionMain?.imageDescription)

    // optionMain
    setOptionAMain(optionMain && optionMain[0])
    setOptionBMain(optionMain && optionMain[1])
    setOptionCMain(optionMain && optionMain[2])
    setOptionDMain(optionMain && optionMain[3])
    setOptionEMain(optionMain && optionMain[4])

    // questionMulti
    setQuestionTextMulti(questionMulti?.questionText)
    setImageQuestionMulti(questionMulti?.imageQuestion)
    setCorrectAnswerMulti1(questionMulti?.correctAnswer1)
    setCorrectAnswerMulti2(questionMulti?.correctAnswer2)
    setIconDescriptionMulti(questionMulti?.iconDescription)
    setDescriptionMulti(questionMulti?.description)
    setImageDescriptionMulti(questionMulti?.imageDescription)

    // optionMulti
    setOptionAMulti(optionMulti && optionMulti[0])
    setOptionBMulti(optionMulti && optionMulti[1])
    setOptionCMulti(optionMulti && optionMulti[2])
    setOptionDMulti(optionMulti && optionMulti[3])
    setOptionEMulti(optionMulti && optionMulti[4])

    // questionThreeMulti
    setQuestionTextThreeMulti(questionMulti?.questionText)
    setImageQuestionThreeMulti(questionMulti?.imageQuestion)
    setCorrectAnswerThreeMulti1(questionMulti?.correctAnswer1)
    setCorrectAnswerThreeMulti2(questionMulti?.correctAnswer2)
    setCorrectAnswerThreeMulti3(questionMulti?.correctAnswer3)
    setIconDescriptionThreeMulti(questionMulti?.iconDescription)
    setDescriptionThreeMulti(questionMulti?.description)
    setImageDescriptionThreeMulti(questionMulti?.imageDescription)

    // optionThreeMulti
    setOptionAThreeMulti(optionMulti && optionMulti[0])
    setOptionBThreeMulti(optionMulti && optionMulti[1])
    setOptionCThreeMulti(optionMulti && optionMulti[2])
    setOptionDThreeMulti(optionMulti && optionMulti[3])
    setOptionEThreeMulti(optionMulti && optionMulti[4])
    setOptionFThreeMulti(optionMulti && optionMulti[5])

  }

  function closeModal() {
    setModalIsOpen(false)
    setActivePopupcheckAlternativeAnswerModalForms1(false) // fechar o popup 'PopupCheckAlternativeAnswer' do form1 ao fechar a modal
    setActivePopupcheckAlternativeAnswerModalForms2(false) // fechar o popup 'PopupCheckAlternativeAnswer' do form2 ao fechar a modal
    setActivePopupcheckAlternativeAnswerModalForms3(false) // fechar o popup 'PopupCheckAlternativeAnswer' do form3 ao fechar a modal

  }

  useEffect(() => {
    function voidFieldModalEdit () { // função para capturar os campos obrigatórios que estão vazios
      if (activePageMain) {
        const fields = {
          questionTextMain,
          correctAnswerMain,
          descriptionMain,
          optionAMain,
          optionBMain,
          optionCMain,
          optionDMain
        }
        
        const voidFieldFilter = Object.entries(fields)
          .filter(([key, value]) => !value)
          .map(([key]) => key)
  
        setVoidField(voidFieldFilter)
  
      } else if (activePageMulti) {
        const fields = {
          questionTextMulti,
          correctAnswerMulti1,
          correctAnswerMulti2,
          descriptionMulti,
          optionAMulti,
          optionBMulti,
          optionCMulti,
          optionDMulti
        }
  
        const voidFieldFilter = Object.entries(fields)
          .filter(([key, value]) => !value)
          .map(([key]) => key)
  
        setVoidField(voidFieldFilter)
  
      } else if (activePageThreeMulti) {
        const fields = {
          questionTextThreeMulti,
          correctAnswerThreeMulti1, 
          correctAnswerThreeMulti2,
          correctAnswerThreeMulti3,
          descriptionThreeMulti,
          optionAThreeMulti,
          optionBThreeMulti,
          optionCThreeMulti,
          optionDThreeMulti,
          optionEThreeMulti,
          optionFThreeMulti
        }
  
        const voidFieldFilter = Object.entries(fields)
          .filter(([key, value]) => !value)
          .map(([key]) => key)
  
        setVoidField(voidFieldFilter)
  
      }

    }

    voidFieldModalEdit()

  }, [activePageMain, activePageMulti, activePageThreeMulti, 
    questionTextMain, correctAnswerMain, descriptionMain, optionAMain, optionBMain, optionCMain, optionDMain, 
    questionTextMulti, correctAnswerMulti1, correctAnswerMulti2, descriptionMulti, optionAMulti, optionBMulti, optionCMulti, optionDMulti,
    questionTextThreeMulti, correctAnswerThreeMulti1, correctAnswerThreeMulti2, correctAnswerThreeMulti3, descriptionThreeMulti, optionAThreeMulti, optionBThreeMulti, optionCThreeMulti, optionDThreeMulti, optionEThreeMulti, optionFThreeMulti
    ])

  // função que limpa todos os campos do formulário
  function cleanForm() {
    if (activePageDemo) {
      setStaticQuestionClearDisabledAlert(true)

    } else {
      if (activePageMain && questionMain && optionMain) {
        setQuestionTextMain('')
        setImageQuestionMain('')
        setCorrectAnswerMain('')
        setIconDescriptionMain('')
        setDescriptionMain('')
        setImageDescriptionMain('')
        setOptionAMain('')
        setOptionBMain('')
        setOptionCMain('')
        setOptionDMain('')
        setOptionEMain('')

      } else if (activePageMulti && questionMulti && optionMulti) {
        setQuestionTextMulti('')
        setImageQuestionMulti('')
        setCorrectAnswerMulti1('')
        setCorrectAnswerMulti2('')
        setIconDescriptionMulti('')
        setDescriptionMulti('')
        setImageDescriptionMulti('')
        setOptionAMulti('')
        setOptionBMulti('')
        setOptionCMulti('')
        setOptionDMulti('')
        setOptionEMulti('')

      } else if (activePageThreeMulti && questionMulti && optionMulti) {
        setQuestionTextThreeMulti('')
        setImageQuestionThreeMulti('')
        setCorrectAnswerThreeMulti1('')
        setCorrectAnswerThreeMulti2('')
        setCorrectAnswerThreeMulti3('')
        setIconDescriptionThreeMulti('')
        setDescriptionThreeMulti('')
        setImageDescriptionThreeMulti('')
        setOptionAThreeMulti('')
        setOptionBThreeMulti('')
        setOptionCThreeMulti('')
        setOptionDThreeMulti('')
        setOptionEThreeMulti('')
        setOptionFThreeMulti('')

      }
    
    }
      
  }

  function activePopupAlreadySaved() {
    let active

    // formulário 1
    const questionMainEdit = listUnicQuestionsContext.map(questions => [questions.questionText, questions.imageQuestion, questions.correctAnswer, questions.iconDescription, questions.description, questions.imageDescription]) // armazenando uma nova lista de questões do 'backend', sem o número das questões
    const optionMainEdit = listUnicOptionsContext.map(options => [options.optionA, options.optionB, options.optionC, options.optionD, options.optionE]) // armazenando uma nova lista de opções do 'backend', sem o número das opções

    const newListUnicQuestionsContext = [questionTextMain, imageQuestionMain, correctAnswerMain, iconDescriptionMain, descriptionMain, imageDescriptionMain] // armazenando os valores dos campos da questão única editada da 'ModalEdit'
    const newListUnicOptionsContext = [optionAMain, optionBMain, optionCMain, optionDMain, optionEMain] // armazenando os valores dos campos da opção única editada da 'ModalEdit'
    
    const findQuestionMain = questionMainEdit.filter(question => isEqual(question, newListUnicQuestionsContext))[0] // comparação usando a biblioteca 'isEqual'
    const findOptionMain = optionMainEdit.filter(question => isEqual(question, newListUnicOptionsContext))[0] // comparação usando a biblioteca 'isEqual'

    // formulário 2    
    const questionMultiEdit = listMultiQuestionsContext.map(questions => [questions.questionText, questions.imageQuestion, questions.correctAnswer1, questions.correctAnswer2, questions.iconDescription, questions.description, questions.imageDescription]) // armazenando uma nova lista de questões do 'backend', sem o número das questões
    const optionMultiEdit = listMultiOptionsContext.map(options => [options.optionA, options.optionB, options.optionC, options.optionD, options.optionE]) // armazenando uma nova lista de opções do 'backend', sem o número das opções

    const newListMultiQuestionsContext = [questionTextMulti, imageQuestionMulti, correctAnswerMulti1, correctAnswerMulti2, iconDescriptionMulti, descriptionMulti, imageDescriptionMulti] // armazenando os valores dos campos da questão múltipla editada da 'ModalEdit'
    const newListMultiOptionsContext = [optionAMulti, optionBMulti, optionCMulti, optionDMulti, optionEMulti] // armazenando os valores dos campos da opção múltipla editada da 'ModalEdit'

    const findQuestionMulti = questionMultiEdit.filter(question => isEqual(question, newListMultiQuestionsContext))[0] // comparação usando a biblioteca 'isEqual'
    const findOptionMulti = optionMultiEdit.filter(question => isEqual(question, newListMultiOptionsContext))[0] // comparação usando a biblioteca 'isEqual'

    // formulário 3    
    const questionThreeMultiEdit = listThreeMultiQuestionsContext.map(questions => [questions.questionText, questions.imageQuestion, questions.correctAnswer1, questions.correctAnswer2, questions.correctAnswer3, questions.iconDescription, questions.description, questions.imageDescription]) // armazenando uma nova lista de questões do 'backend', sem o número das questões
    const optionThreeMultiEdit  = listThreeMultiOptionsContext.map(options => [options.optionA, options.optionB, options.optionC, options.optionD, options.optionE, options.optionF]) // armazenando uma nova lista de opções do 'backend', sem o número das opções

    const newListThreeMultiQuestionsContext  = [questionTextThreeMulti, imageQuestionThreeMulti, correctAnswerThreeMulti1, correctAnswerThreeMulti2, correctAnswerThreeMulti3, iconDescriptionThreeMulti, descriptionThreeMulti, imageDescriptionThreeMulti] // armazenando os valores dos campos da questão múltipla editada da 'ModalEdit'
    const newListThreeMultiOptionsContext = [optionAThreeMulti, optionBThreeMulti, optionCThreeMulti, optionDThreeMulti, optionEThreeMulti, optionFThreeMulti] // armazenando os valores dos campos da opção múltipla editada da 'ModalEdit'

    const findQuestionThreeMulti = questionThreeMultiEdit.filter(question => isEqual(question, newListThreeMultiQuestionsContext))[0] // comparação usando a biblioteca 'isEqual'
    const findOptionThreeMulti = optionThreeMultiEdit.filter(question => isEqual(question, newListThreeMultiOptionsContext))[0] // comparação usando a biblioteca 'isEqual'

    if (activePageMain && findQuestionMain && findOptionMain) {
    // condição: se a questão ou opção única editada já existe no 'backend'
      active = true

    } else if (activePageMulti && findQuestionMulti && findOptionMulti) {
    // condição: se a questão ou opção múltipla editada já existe no 'backend'
      active = true

    } else if (activePageThreeMulti && findQuestionThreeMulti && findOptionThreeMulti) {
    // condição: se a questão ou opção múltipla editada já existe no 'backend'
      active = true

    } else {
      active = false
      
    }
    
    return active

  }

  //função utilizando PUT para alterar as questões na API
  async function onSaveModalQuestion() {
    const jsonBody = JSON.stringify({
      questionText: questionTextMain,
      imageQuestion: imageQuestionMain,
      correctAnswer: correctAnswerMain,
      iconDescription: iconDescriptionMain,
      description: descriptionMain,
      imageDescription: imageDescriptionMain,
      questionNumber: questionMain.questionNumber, // não será alterado
      id: questionMain.id // não será alterado

    })
    await fetch(`http://localhost:3001/listQuestionsMain/${questionMain.id}`, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json"
      },
      body: jsonBody

    })
    .then((res) => res.json())
    .then((data) => {
      console.log(data)

    }) 
    .catch((error) => {
        console.log(error)

    })

  }

  //função utilizando PUT para alterar as opções na API
  async function onSaveModalOption() {
    const jsonBody = JSON.stringify({
      optionA: optionAMain,
      optionB: optionBMain,
      optionC: optionCMain,
      optionD: optionDMain,
      optionE: optionEMain,
      optionNumber: optionMainNumberId[0], // não será alterado 
      id: optionMainNumberId[1] // não será alterado

    })
    await fetch(`http://localhost:3001/listOptionsMain/${optionMainNumberId[1]}`, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json"
      },
      body: jsonBody
    })

    .then((res) => res.json())
    .then((data) => {
      console.log(data)

    }) 
    .catch((error) => {
      console.log(error)

    })

  }

  //função utilizando PUT para alterar as questões de múltipla escolha na API
  async function onSaveModalMultiQuestion() {
    const jsonBody = JSON.stringify({
      questionText: questionTextMulti,
      imageQuestion: imageQuestionMulti,
      correctAnswer1: correctAnswerMulti1,
      correctAnswer2: correctAnswerMulti2,
      iconDescription: iconDescriptionMulti,
      description: descriptionMulti,
      imageDescription: imageDescriptionMulti,
      questionNumber: questionMulti.questionNumber, // não será alterado
      id: questionMulti.id // não será alterado

    })
    await fetch(`http://localhost:3001/listQuestionsMulti/${questionMulti.id}`, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json"
      },
      body: jsonBody

    })

    .then((res) => res.json())
    .then((data) => {
      console.log(data)

    }) 
    .catch((error) => {
      console.log(error)

    })

  }

  //função utilizando PUT para alterar as opções de múltipla escolha na API
  async function onSaveModalMultiOption() {
    const jsonBody = JSON.stringify({
      optionA: optionAMulti,
      optionB: optionBMulti,
      optionC: optionCMulti,
      optionD: optionDMulti,
      optionE: optionEMulti,
      optionNumber: optionMultiNumberId[0], // não será alterado 
      id: optionMultiNumberId[1] // não será alterado

    })
    await fetch(`http://localhost:3001/listOptionsMulti/${optionMultiNumberId[1]}`, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json"
      },
      body: jsonBody

    })
    .then((res) => res.json())
    .then((data) => {
      console.log(data)
      
    }) 

    .catch((error) => {
      console.log(error)
    }) 

  }

  //função utilizando PUT para alterar as questões de múltipla escolha na API
  async function onSaveModalThreeMultiQuestion() {
    const jsonBody = JSON.stringify({
      questionText: questionTextThreeMulti,
      imageQuestion: imageQuestionThreeMulti,
      correctAnswer1: correctAnswerThreeMulti1,
      correctAnswer2: correctAnswerThreeMulti2,
      correctAnswer3: correctAnswerThreeMulti3,
      iconDescription: iconDescriptionThreeMulti,
      description: descriptionThreeMulti,
      imageDescription: imageDescriptionThreeMulti,
      questionNumber: questionMulti.questionNumber, // não será alterado
      id: questionMulti.id // não será alterado

    })
    await fetch(`http://localhost:3001/listQuestionsThreeMulti/${questionMulti.id}`, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json"
      },
      body: jsonBody

    })

    .then((res) => res.json())
    .then((data) => {
      console.log(data)

    }) 
    .catch((error) => {
      console.log(error)

    })

  }

  //função utilizando PUT para alterar as opções de múltipla escolha na API
  async function onSaveModalThreeMultiOption() {
    const jsonBody = JSON.stringify({
      optionA: optionAThreeMulti,
      optionB: optionBThreeMulti,
      optionC: optionCThreeMulti,
      optionD: optionDThreeMulti,
      optionE: optionEThreeMulti,
      optionF: optionFThreeMulti,
      optionNumber: optionMultiNumberId[0], // não será alterado 
      id: optionMultiNumberId[1] // não será alterado

    })
    await fetch(`http://localhost:3001/listOptionsThreeMulti/${optionMultiNumberId[1]}`, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json"
      },
      body: jsonBody

    })
    .then((res) => res.json())
    .then((data) => {
      console.log(data)
      
    }) 

    .catch((error) => {
      console.log(error)
    }) 

  }

  // função que vai salvar quaisquer alterações feitas na questão e opção atual (função usada para ativar duas funções 'fetch de método PUT')
  function multiFunctionsNewPageMain(event) {
    event.preventDefault()

    if (activePageDemo) { // se a página demo estiver aberta
      setStaticQuestionEditAlert(true)

    } else if (!questionTextMain || !correctAnswerMain || !descriptionMain || !questionNumberMain || !optionAMain ||
      !optionBMain || !optionCMain || !optionDMain) { // se tiver algum campo obrigatório vazio
        console.error("One or more fields are empty.")

    } else {
      if (activePopupAlreadySaved() === true) {
        setActivePopupAlreadySavedModalEdit(true) // habilita o 'PopupAlreadySavedModalEdit'

      } else {
        setActivePopupAlreadySavedModalEdit(false) // desabilita o 'PopupAlreadySavedModalEdit'

        if (checkAlternativeAnswerDefault(newOption, null, null, correctAnswerMain) === true) {
          setActivePopupcheckAlternativeAnswerModalForms1(true)

        } else if (repeatedAlternativesDefault(newOption).length > 0) {
          setActivePopupRepeatedAlternativesModalEdit(true)

        } else {
          onSaveModalQuestion() // salvando a questão única
          onSaveModalOption() // salvando a opção única

          setActivePopupRepeatedAlternativesModalEdit(false) // desativar o popup, caso esteja visível na tela
          console.log('Saved successfully!')
          setPutApi(!putApi)
          setActiveModalEditMenu(true) // mostrará que esta Modal está ativada
          setTimeout(() => setActiveModalEditMenu(false), 300) // mostrará que esta Modal está desativada em 300ms, tempo que atualiza a questão que permanecerá
          closeModal()

        } 

      }

    }

  }

  // função que vai salvar quaisquer alterações feitas na questão e opção de múltipla escolha atual (função usada para ativar duas funções 'fetch de método PUT')
  function multiFunctionsPageMulti(event) {
    event.preventDefault()

    if (!questionTextMulti || !correctAnswerMulti1 || !correctAnswerMulti2 || !descriptionMulti || !questionNumberMulti || !optionAMulti ||
      !optionBMulti || !optionCMulti || !optionDMulti) { // se tiver algum campo obrigatório vazio
        console.error("One or more fields are empty.")

    } else {
      if (activePopupAlreadySaved() === true) {
        setActivePopupAlreadySavedModalEdit(true) // habilita o 'PopupAlreadySavedModalEdit'

      } else {
        setActivePopupAlreadySavedModalEdit(false) // desabilita o 'PopupAlreadySavedModalEdit'

        if (checkAlternativeAnswerDefault(null, newMultiOption, null, [correctAnswerMulti1, correctAnswerMulti2]) === true) {
          setActivePopupcheckAlternativeAnswerModalForms2(true)

        } else if (checkAnswers(correctAnswerMulti1, correctAnswerMulti2)[0] === true) {
          setCheckEqualAnswersMulti(true)

        } else if (repeatedAlternativesDefault(null, newMultiOption).length > 0) {
          setActivePopupRepeatedAlternativesModalEdit(true)

        } else {    
          onSaveModalMultiQuestion() // salvando a questão múltipla
          onSaveModalMultiOption() // salvando a opção múltipla
          
          setActivePopupRepeatedAlternativesModalEdit(false) // desativar o popup, caso esteja visível na tela
          console.log('Saved successfully!')
          setPutApi(!putApi)
          closeModal()

        }
      
      }

    }

  }

  // função que vai salvar quaisquer alterações feitas na questão e opção de múltipla escolha atual (função usada para ativar duas funções 'fetch de método PUT')
  function multiFunctionsPageThreeMulti(event) {
    event.preventDefault()

    if (!questionTextThreeMulti || !correctAnswerThreeMulti1 || !correctAnswerThreeMulti2 || !correctAnswerThreeMulti3 || !descriptionThreeMulti || !questionNumberThreeMulti || !optionAThreeMulti ||
      !optionBThreeMulti || !optionCThreeMulti || !optionDThreeMulti || !optionEThreeMulti || !optionFThreeMulti) { // se tiver algum campo obrigatório vazio
        console.error("One or more fields are empty.")

    } else {
      if (activePopupAlreadySaved() === true) {
        setActivePopupAlreadySavedModalEdit(true) // habilita o 'PopupAlreadySavedModalEdit'

      } else {
        setActivePopupAlreadySavedModalEdit(false) // desabilita o 'PopupAlreadySavedModalEdit'

        if (checkAlternativeAnswerDefault(null, null, newThreeMultiOption, [correctAnswerThreeMulti1, correctAnswerThreeMulti2, correctAnswerThreeMulti3]) === true) {
          setActivePopupcheckAlternativeAnswerModalForms3(true)

        } else if (checkAnswers(null, null, correctAnswerThreeMulti1, correctAnswerThreeMulti2, correctAnswerThreeMulti3)[1] === true) {
          setCheckEqualAnswersThreeMulti(true)

        } else if (repeatedAlternativesDefault(null, null, newThreeMultiOption).length > 0) {
          setActivePopupRepeatedAlternativesModalEdit(true)

        } else {    
          onSaveModalThreeMultiQuestion() // salvando a questão múltipla
          onSaveModalThreeMultiOption() // salvando a opção múltipla
          
          setActivePopupRepeatedAlternativesModalEdit(false) // desativar o popup, caso esteja visível na tela
          console.log('Saved successfully!')
          setPutApi(!putApi)
          closeModal()

        } 
      
      }

    }

  }

  return (
    <div className={styles.container}>
      <div
          onClick={openModal}
          className={styles.iconsTexts}
      >
        {activeDescriptionIcon && 
          <DescriptionIconMenuTools 
            activeDescriptionIcon={activeDescriptionIcon} 
            key={'edit'} 
            text={'edit'}
          />
        }

        <MdEditSquare
        onMouseOver={() => setActiveDescriptionIcon('edit')}
        onMouseOut={() => setActiveDescriptionIcon('')}
        className={styles.editIcon}
        />                

      </div>

      <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Modal"
          overlayClassName={styles.modalOverlay}
          className={styles.modalContent}
      >
        <div className={styles.containerTitleIconDelete}>
          <h1>EDIT CARD</h1>

          {/* imagem delete do react icon */}
          <TiDeleteOutline
              onClick={() => {closeModal(); mute === false && audioClick.play()}} 
              className={styles.modalImageDelete} 
          />      

        </div>

        {/* Demo e Main form */}
        {(activePageDemo || activePageMain) && questionMain && optionMain && 
        <form // form1, este form só aparecerá se tiver uma questão e opção da PageMain
          onSubmit={(event) => multiFunctionsNewPageMain(event)}
          className={styles.formModal}
        > 
          {/* todos os campos das questões */}
          <FieldModalEdit
            newValue={questionTextMain}
            onChangeModal={(e) => setQuestionTextMain(e.target.value)}
            name="Question:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'questionTextMain'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={imageQuestionMain}
            onChangeModal={(e) => setImageQuestionMain(e.target.value)}
            name="Image Question:"
          />

          <FieldModalEdit
            newValue={correctAnswerMain}
            onChangeModal={(e) => setCorrectAnswerMain(e.target.value)}
            name="Answer:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'correctAnswerMain'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={iconDescriptionMain}
            onChangeModal={(e) => setIconDescriptionMain(e.target.value)}
            name="Icon Description:"
          />

          <FieldModalEdit
            newValue={descriptionMain}
            onChangeModal={(e) => setDescriptionMain(e.target.value)}
            name="Description:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'descriptionMain'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={imageDescriptionMain}
            onChangeModal={(e) => setImageDescriptionMain(e.target.value)}
            name="Image Description:"
          />

          {/* todos os campos das opções */}
          <FieldModalEdit
            newValue={optionAMain}
            onChangeModal={(e) => setOptionAMain(e.target.value)}
            name="OptionA:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionAMain'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionBMain}
            onChangeModal={(e) => setOptionBMain(e.target.value)}
            name="OptionB:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionBMain'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionCMain}
            onChangeModal={(e) => setOptionCMain(e.target.value)}
            name="OptionC:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionCMain'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionDMain}
            onChangeModal={(e) => setOptionDMain(e.target.value)}
            name="OptionD:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionDMain'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionEMain}
            onChangeModal={(e) => setOptionEMain(e.target.value)}
            name="OptionE:"
          />

          {/* Botões submit e clean */}
          <div className={styles.buttons}>
            <ButtonDefault
              onClick={() => {repeatedAlternativesDefault(newOption); mute === false && audioClick.play()}}
              buttonName='Save' 
              specificType='submit'
              specificStyleButton={styles.button}

            />
            <ButtonDefault 
              onClick={() => {cleanForm(); mute === false && audioClick.play()}}
              buttonName='Clean' 
              specificType='button'
              specificStyleButton={styles.button}
              
            />

          </div>
        
        </form>}

        {/* Multi form */}
        {activePageMulti && questionMulti && optionMulti && 
        <form // form2, este form só aparecerá se tiver uma questão e opção da PageMulti
          onSubmit={multiFunctionsPageMulti}
          className={styles.formModal}
        > 
          {/* todos os campos das questões de múltipla escolha */}
          <FieldModalEdit
            newValue={questionTextMulti}
            onChangeModal={(e) => setQuestionTextMulti(e.target.value)}
            name="Question:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'questionTextMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={imageQuestionMulti}
            onChangeModal={(e) => setImageQuestionMulti(e.target.value)}
            name="Image Question:"
          />

          <FieldModalEdit
            newValue={correctAnswerMulti1}
            onChangeModal={(e) => setCorrectAnswerMulti1(e.target.value)}
            name="Answer1:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'correctAnswerMulti1'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={correctAnswerMulti2}
            onChangeModal={(e) => setCorrectAnswerMulti2(e.target.value)}
            name="Answer2:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'correctAnswerMulti2'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={iconDescriptionMulti}
            onChangeModal={(e) => setIconDescriptionMulti(e.target.value)}
            name="Icon Description:"
          />

          <FieldModalEdit
            newValue={descriptionMulti}
            onChangeModal={(e) => setDescriptionMulti(e.target.value)}
            name="Description:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'descriptionMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={imageDescriptionMulti}
            onChangeModal={(e) => setImageDescriptionMulti(e.target.value)}
            name="Image Description:"
          />

          {/* todos os campos das opções de múltipla escolha */}
          <FieldModalEdit
            newValue={optionAMulti}
            onChangeModal={(e) => setOptionAMulti(e.target.value)}
            name="OptionA:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionAMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionBMulti}
            onChangeModal={(e) => setOptionBMulti(e.target.value)}
            name="OptionB:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionBMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionCMulti}
            onChangeModal={(e) => setOptionCMulti(e.target.value)}
            name="OptionC:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionCMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionDMulti}
            onChangeModal={(e) => setOptionDMulti(e.target.value)}
            name="OptionD:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionDMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionEMulti}
            onChangeModal={(e) => setOptionEMulti(e.target.value)}
            name="OptionE:"
          />

          {/* Botões submit e clean */}
          <div className={styles.buttons}>
            <ButtonDefault
              onClick={() => {repeatedAlternativesDefault(null, newMultiOption); mute === false && audioClick.play()}}
              buttonName='Save' 
              specificType='submit'
              specificStyleButton={styles.button}
            />
            <ButtonDefault
              onClick={() => {cleanForm(); mute === false && audioClick.play()}}
              buttonName='Clean' 
              specificType='button'
              specificStyleButton={styles.button}   
            />

          </div>
        
        </form>}

        {/* threeMulti form */}
        {activePageThreeMulti && questionMulti && optionMulti && 
        <form // form2, este form só aparecerá se tiver uma questão e opção da PageMulti
          onSubmit={multiFunctionsPageThreeMulti}
          className={styles.formModal}
        > 
          {/* todos os campos das questões de múltipla escolha */}
          <FieldModalEdit
            newValue={questionTextThreeMulti}
            onChangeModal={(e) => setQuestionTextThreeMulti(e.target.value)}
            name="Question:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'questionTextThreeMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={imageQuestionThreeMulti}
            onChangeModal={(e) => setImageQuestionThreeMulti(e.target.value)}
            name="Image Question:"
          />

          <FieldModalEdit
            newValue={correctAnswerThreeMulti1}
            onChangeModal={(e) => setCorrectAnswerThreeMulti1(e.target.value)}
            name="Answer1:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'correctAnswerThreeMulti1'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={correctAnswerThreeMulti2}
            onChangeModal={(e) => setCorrectAnswerThreeMulti2(e.target.value)}
            name="Answer2:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'correctAnswerThreeMulti2'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={correctAnswerThreeMulti3}
            onChangeModal={(e) => setCorrectAnswerThreeMulti3(e.target.value)}
            name="Answer3:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'correctAnswerThreeMulti3'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={iconDescriptionThreeMulti}
            onChangeModal={(e) => setIconDescriptionThreeMulti(e.target.value)}
            name="Icon Description:"
          />

          <FieldModalEdit
            newValue={descriptionThreeMulti}
            onChangeModal={(e) => setDescriptionThreeMulti(e.target.value)}
            name="Description:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'descriptionThreeMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={imageDescriptionThreeMulti}
            onChangeModal={(e) => setImageDescriptionThreeMulti(e.target.value)}
            name="Image Description:"
          />

          {/* todos os campos das opções de múltipla escolha */}
          <FieldModalEdit
            newValue={optionAThreeMulti}
            onChangeModal={(e) => setOptionAThreeMulti(e.target.value)}
            name="OptionA:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionAThreeMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionBThreeMulti}
            onChangeModal={(e) => setOptionBThreeMulti(e.target.value)}
            name="OptionB:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionBThreeMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionCThreeMulti}
            onChangeModal={(e) => setOptionCThreeMulti(e.target.value)}
            name="OptionC:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionCThreeMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionDThreeMulti}
            onChangeModal={(e) => setOptionDThreeMulti(e.target.value)}
            name="OptionD:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionDThreeMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionEThreeMulti}
            onChangeModal={(e) => setOptionEThreeMulti(e.target.value)}
            name="OptionE:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionEThreeMulti'}
            voidField={voidField}
          />

          <FieldModalEdit
            newValue={optionFThreeMulti}
            onChangeModal={(e) => setOptionFThreeMulti(e.target.value)}
            name="OptionF:*"
            errorMessageText={errorMessageModalEdit}
            errorTargetLabel={'optionFThreeMulti'}
            voidField={voidField}
          />

          {/* Botões submit e clean */}
          <div className={styles.buttons}>
            <ButtonDefault
              onClick={() => {repeatedAlternativesDefault(null, null, newThreeMultiOption); mute === false && audioClick.play()}}
              buttonName='Save' 
              specificType='submit'
              specificStyleButton={styles.button}
            />
            <ButtonDefault
              onClick={() => {cleanForm(); mute === false && audioClick.play()}}
              buttonName='Clean' 
              specificType='button'
              specificStyleButton={styles.button}   
            />

          </div>
        
        </form>}

        {/* PopupRepeatedAlternatives */}
        {activePopupRepeatedAlternativesModalEdit && 
          <PopupRepeatedAlternatives 
            specificStyles={styles.popupRepeatedModalEdit} 
            textPopup={"There are repeated alternatives. Please, before editing the option, modify the duplicated alternatives and then proceed with editing the question and the option."} 
            activePopup={setActivePopupRepeatedAlternativesModalEdit}            
          />
        }

        {/* PopupCheckAlternativeAnswer */}
        {activePopupcheckAlternativeAnswerModalForms1 && 
          <PopupCheckAlternativeAnswer 
            specificStyles={styles.popupCheckModalForm} 
            activePopup={setActivePopupcheckAlternativeAnswerModalForms1}
            textPopup={`No alternative matching the answer (Answer : ${correctAnswerMain}) to question was found in the options. Please ensure that, before editing the question and the option, one of the alternatives is exactly the same as the answer to question. Then proceed with editing this question and the option. For more information, click the phrase below.`} 
            textModalDescription={`(Solution 1) Include in the answer (Answer : ${correctAnswerMain}) to question the correct alternative from the option highlighted below: (Option A: ${optionAMain}), (Option B: ${optionBMain}), (Option C: ${optionCMain}), (Option D: ${optionDMain})${optionEMain !== '' ? ` or (Option E: ${optionEMain}).` : `.`} (Solution 2) Include in one of the alternatives of this option the answer, highlighted below: (Answer: ${correctAnswerMain}).`}
          />
        }

        {activePopupcheckAlternativeAnswerModalForms2 && 
          <PopupCheckAlternativeAnswer 
            specificStyles={styles.popupCheckModalForm} 
            activePopup={setActivePopupcheckAlternativeAnswerModalForms2}
            textPopup={`The two answers (Answer 1: ${correctAnswerMulti1}) and (Answer 2: ${correctAnswerMulti2}) of question were not found in the options. Please ensure that, before editing the question and the option, the alternatives (Option A: ${optionAMulti} and (Option B: ${optionBMulti}) are exactly the same as those included in the answers (Answer 1: ${correctAnswerMulti1}) and (Answer 2: ${correctAnswerMulti2}) of question. Then proceed with editing the question and the option. For more information, click the phrase below.`} 
            textModalDescription={`(Solution 1) Include in the answers of question the two correct alternatives from the option highlighted below: (Option A: ${optionAMulti}) and (Option B: ${optionBMulti}). (Solution 2) Include in the first two alternatives (Option A: ${optionAMulti}) and (Option B: ${optionBMulti}) of this option the answers included in question, highlighted below: (Answer 1: ${correctAnswerMulti1}) and (Answer 2: ${correctAnswerMulti2}).`}
          />
        }

        {activePopupcheckAlternativeAnswerModalForms3 && 
          <PopupCheckAlternativeAnswer 
            specificStyles={styles.popupCheckModalForm} 
            activePopup={setActivePopupcheckAlternativeAnswerModalForms3}
            textPopup={`The three answers (Answer 1: ${correctAnswerThreeMulti1}), (Answer 2: ${correctAnswerThreeMulti2}) and (Answer 3: ${correctAnswerThreeMulti3}) of question were not found in the options. Please ensure that, before editing the question and the option, the alternatives (Option A: ${optionAThreeMulti}, (Option B: ${optionBThreeMulti}) and (Option C: ${optionCThreeMulti}) are exactly the same as those included in the answers (Answer 1: ${correctAnswerThreeMulti1}), (Answer 2: ${correctAnswerThreeMulti2}) and (Answer 3: ${correctAnswerThreeMulti3}) of question. Then proceed with editing the question and the option. For more information, click the phrase below.`} 
            textModalDescription={`(Solution 1) Include in the answer of question the three correct alternatives from the option highlighted below: (Option A: ${optionAThreeMulti}), (Option B: ${optionBThreeMulti}) and (Option C: ${optionCThreeMulti}). (Solution 2) Include in the first three alternatives (Option A: ${optionAThreeMulti}), (Option B: ${optionBThreeMulti}) and (Option C: ${optionCThreeMulti}) of this option the answers included in question, highlighted below: (Answer 1: ${correctAnswerThreeMulti1}), (Answer 2: ${correctAnswerThreeMulti2}) and (Answer 3: ${correctAnswerThreeMulti3}).`}
          />
        }

        {/* PopupAlreadySavedModalEdit */}
        {activePopupAlreadySavedModalEdit &&  
          <PopupAlreadySavedModalEdit
            specificStyles={styles.popupAlreadySaved} 
            activePopup={setActivePopupAlreadySavedModalEdit}
            textPopup={'No changes detected. Please update one or more fields and try saving again.'}
          />
        }

        {/* {PopupAlertMessage} */}
        {staticQuestionEditAlert &&
          <PopupAlertMessage 
            text="This is a static question and cannot be edited here."
            activePopup={setStaticQuestionEditAlert}
            specificStyles={styles.popupAlertMessage}
          />
        }

        {staticQuestionClearDisabledAlert &&
          <PopupAlertMessage 
            text="This is a static question and clearing is disabled."
            activePopup={setStaticQuestionClearDisabledAlert}
            specificStyles={styles.popupAlertMessage}
          />
        }

        {checkEqualAnswersMulti &&
          <PopupAlertMessage 
            text={`The answers for this question (Answer 1: ${correctAnswerMulti1}) and (Answer 2: ${correctAnswerMulti2}) are all the same. Please revise them.`}
            activePopup={setCheckEqualAnswersMulti}
            specificStyles={styles.popupAlertMessage}
          />
        }

        {checkEqualAnswersThreeMulti &&
          <PopupAlertMessage 
            text={`The answers for this question ${(correctAnswerThreeMulti1 === correctAnswerThreeMulti2) && (correctAnswerThreeMulti1 === correctAnswerThreeMulti3) && (correctAnswerThreeMulti2 === correctAnswerThreeMulti3) ? 
              `(Answer 1: ${correctAnswerThreeMulti1}), (Answer 2: ${correctAnswerThreeMulti2}) and (Answer 3: ${correctAnswerThreeMulti3})` : 
              correctAnswerThreeMulti1 === correctAnswerThreeMulti2 ? `(Answer 1: ${correctAnswerThreeMulti1}), (Answer 2: ${correctAnswerThreeMulti2})` : 
              correctAnswerThreeMulti1 === correctAnswerThreeMulti3 ? `(Answer 1: ${correctAnswerThreeMulti1}), (Answer 3: ${correctAnswerThreeMulti3})` : 
              correctAnswerThreeMulti2 === correctAnswerThreeMulti3 ? `(Answer 2: ${correctAnswerThreeMulti2}), (Answer 3: ${correctAnswerThreeMulti3})` : null} 
              are all the same. Please revise them.`}
            activePopup={setCheckEqualAnswersThreeMulti}
            specificStyles={styles.popupAlertMessage}
          />
        }
      
      </Modal>

    </div>

  )
}

export default ModalEditMenu;
